// extracted by mini-css-extract-plugin
module.exports = {"container":"iw-z","modal":"jw-z","dimensions":"kw-z","brandName":"lw-z","productName":"mw-z","recipientEmail":"nw-z","recommendedFit":"ow-z","hiddenField":"pw-z"};